const STORAGE_KEY = 'tracker_browser_notifications_enabled';

export function readBrowserNotificationsUserEnabled(): boolean {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === null) return true;
    return v === '1' || v === 'true';
  } catch {
    return true;
  }
}

export function writeBrowserNotificationsUserEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore */
  }
}

/** Уведомления доступны только в secure context: https, localhost, 127.0.0.1. */
export function notificationsAreSupportedInThisContext(): boolean {
  if (typeof Notification === 'undefined') return false;
  if (typeof window !== 'undefined' && window.isSecureContext === false) return false;
  return true;
}

/**
 * Запрос разрешения. Важно: не вызывайте React setState до этого промиса из того же обработчика клика —
 * иначе Chrome может не показать диалог (теряется user activation).
 */
export async function requestBrowserNotificationPermission(): Promise<NotificationPermission> {
  if (typeof Notification === 'undefined') {
    return 'denied';
  }
  if (!notificationsAreSupportedInThisContext()) {
    return 'denied';
  }
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}
